<!--
  TRANSFERENCIA DESDE TU BANCO
-->
<h1>{{ 'transferTitle' | translation | async }}</h1>
<app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
<ng-container *ngIf="transferNetworkCode === interbankRedCode; else notInterbank ">
  <div class="methodForm">
    <h2>{{ 'transferSubtitle' | translation | async }}</h2>
    <app-counter-item [number]="1">
       <span innerHTML="{{ 'transfer-instructions-step-one-interbank' | translation | async }}"></span>
    </app-counter-item>
    <br>
    <app-counter-item [number]="2">
      <span innerHTML="{{ 'transfer-instructions-step-two-interbank' | translation | async }}"></span>
      <app-copy-to-clipboard style="flex: 2" [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
    </app-counter-item>
    <br>
    <app-counter-item [number]="3">
       <span innerHTML="{{ 'transfer-instructions-step-four' | translation | async }}"></span>
    </app-counter-item>

    <div class="otherInfo" *ngIf="notPER()">
      <p *ngIf="notCRC(); else important_content" innerHTML="{{ 'cash-DocInfo' | translation | async }}"></p>
      <ng-template #important_content>
        <p innerHTML="{{ 'html-important' | translation | async }}"></p>
      </ng-template>
      <p innerHTML="{{ 'cash-AproveTime' | translation | async }}"></p>
    </div>
  </div>
</ng-container>
<ng-template #notInterbank>
  <div class="methodForm">
  <h2>{{ 'transferSubtitle' | translation | async }}</h2>
  <app-counter-item [number]="1">
    <span innerHTML="{{ 'transfer-instructions-step-one' | translation | async }}"></span>
  </app-counter-item>
  <app-counter-item [number]="2">
    <span innerHTML="{{ 'transfer-instructions-step-two' | translation | async }}"></span>
  </app-counter-item>
  <app-counter-item [number]="3">
    <span innerHTML="{{ 'transfer-instructions-step-three' | translation | async }}"></span>
    <app-copy-to-clipboard style="flex: 2" [value]="transaction.ORDER_REFERENCE"></app-copy-to-clipboard>
  </app-counter-item>
  <app-counter-item [number]="4">
    <span innerHTML="{{ 'transfer-instructions-step-four' | translation | async }}"></span>
  </app-counter-item>

  <div class="otherInfo" *ngIf="notPER()">
    <p *ngIf="notCRC(); else important_content" innerHTML="{{ 'cash-DocInfo' | translation | async }}"></p>
    <ng-template #important_content>
      <p innerHTML="{{ 'html-important' | translation | async }}"></p>
    </ng-template>
    <p innerHTML="{{ 'cash-AproveTime' | translation | async }}"></p>
  </div>
</div>
</ng-template>
